export const initMatomoTagManagerScript = (matomoTagManagerUrl: string) => {
  const _mtm = ((window as any)._mtm = (window as any)._mtm || []);
  _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
  const d = document,
    g = d.createElement('script'),
    s = d.getElementsByTagName('script')[0];
  g.async = true;
  // g.src = 'https://premium.analys.cloud/js/container_CmCkNFNS.js';
  g.src = matomoTagManagerUrl;
  s.parentNode?.insertBefore(g, s);
};
